import { z } from "zod";

const PHONE_PATTERN = /^\+?[0-9\s-]{8,20}$/;

export const updateProfileSchema = z.object({
  fullName: z.string().trim().min(2).max(160).optional(),
  phone: z
    .string()
    .trim()
    .regex(PHONE_PATTERN)
    .or(z.literal(""))
    .transform((value) => (value === "" ? null : value))
    .optional(),
});

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

export const googleLoginQuerySchema = z.object({
  redirect: z.string().max(512).optional(),
});

export const googleCallbackQuerySchema = z.object({
  code: z.string().min(1).optional(),
  state: z.string().min(1).optional(),
  error: z.string().optional(),
});
